import { Modal } from "@/common/components/modal";
import { KeyValueObj } from "@/common/types";
import { ISerialTreeNode, SerialTreeNode } from "./SerialTreeNode";

interface IBatchSerialModalProps {
  isOpen: boolean;
  close: () => void;
  batch: KeyValueObj | null;
}

// MED-652 stage 3: the batch's whole serial tree was already fetched
// eagerly as part of the stage-2 batch list (InventorySerializer#packaging),
// so this modal is a pure render of already-fetched data — no extra request.
export function BatchSerialModal({
  isOpen,
  close,
  batch,
}: IBatchSerialModalProps) {
  const roots: ISerialTreeNode[] = batch?.packaging || [];

  return (
    <Modal
      isOpen={isOpen}
      close={close}
      title={`Batch ${batch?.batch_number || ""}`}
    >
      <div className="w-[56rem] max-w-[92vw] max-h-[65vh] overflow-y-auto px-5 py-4 ">
        {roots.length === 0 ? (
          <p className="text-sm text-gray-500">
            No serialized units found for this batch.
          </p>
        ) : (
          <div className="flex flex-col gap-2">
            {roots.map((root) => (
              <SerialTreeNode key={root.id} node={root} depth={0} />
            ))}
          </div>
        )}
      </div>
    </Modal>
  );
}
